import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { UnifiedBulkItem } from "@src/types/UnifiedBulkRequest";

interface OrderCartState {
  orderCartData: UnifiedBulkItem[];
  shippingData: ShippingMethodsState;
}

type ShippingMethod = {
  id: string;
  name: string;
  cost: number;
  flat_fee?: string;
  description?: string;
  expectedDueDate?: string;
  price_modes?: number[];
};

interface ShippingMethodsState {
  shippingMethods: ShippingMethod[];
  selectedItem: ShippingMethod | null;
}

const initialState: OrderCartState = {
  orderCartData: [],
  shippingData: {
    shippingMethods: [],
    selectedItem: null,
  },
};

export const orderCartSlice = createSlice({
  name: "orderCartSlice",
  initialState,
  reducers: {
    setOrderCartResponse: (state, action: PayloadAction<UnifiedBulkItem[]>) => {
      state.orderCartData = action.payload;
    },
    setShippingMethods: (state, action: PayloadAction<ShippingMethod[]>) => {
      state.shippingData.shippingMethods = action.payload;
      state.shippingData.selectedItem = null;
    },
    setSelectedShippingMethod: (
      state,
      action: PayloadAction<ShippingMethod>
    ) => {
      state.shippingData.selectedItem = action.payload;
    },
    resetShippingData: (state) => {
      state.shippingData = {
        shippingMethods: [],
        selectedItem: null,
      };
    },
  },
});

export const {
  setOrderCartResponse,
  setShippingMethods,
  setSelectedShippingMethod,
  resetShippingData,
} = orderCartSlice.actions;

export const useOrderCartSlice = () => {
  const orderCartData = useSelector(
    (state: { orderCartSlice: OrderCartState }) =>
      state.orderCartSlice.orderCartData
  );
  const shippingData = useSelector(
    (state: { orderCartSlice: OrderCartState }) =>
      state.orderCartSlice.shippingData
  );

  return {
    orderCartData,
    shippingData,
  };
};

export default orderCartSlice.reducer;
